import { trans } from "@/service/i18n/i18n";

export function FormFieldError({ field: { error } }: { field: Field }) {
  if (!error) {
    return <></>;
  }

  return (
    <p
      className="text-destructive text-[0.8rem] font-medium"
      dangerouslySetInnerHTML={{ __html: trans(error) }}
    />
  );
}
